import { ref, onBeforeMount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5717eac0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "left_category_list"
};
const _hoisted_3 = {
  class: "category_list_wrap"
};
const _hoisted_4 = {
  class: "top_header"
};
const _hoisted_5 = {
  key: 0,
  class: "bottom_body"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "right_config_list"
};
const _hoisted_10 = {
  class: "tableContent"
};
const _hoisted_11 = {
  class: "overflowEllipsis1Line"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1));
import { Empty, message } from 'ant-design-vue';
import { getScenarioListFetch, getSubScenarioListFetch, deleteSubScenarioFetch } from '@/api/sandbox';
import { reportEvent } from '@/common';
import TopTitle from './components/TopTitle.vue';
import AddConfigModal from './components/AddConfigModal.vue';
import { columns, configColumns } from './data';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'scenarioConfig'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const scenarioList = ref([]);
    const subScenarioList = ref([]);
    const addCategoryVisible = ref(false);
    const addConfigVisible = ref(false);
    const loading = ref(false);
    const configloading = ref(false);
    const subScenarioItem = ref();
    const curScenarioItem = ref();
    const addCategory = () => {
      addCategoryVisible.value = true;
    };
    const addConfig = () => {
      subScenarioItem.value = {};
      addConfigVisible.value = true;
    };
    const editSubScenario = record => {
      subScenarioItem.value = {
        ...record
      };
      addConfigVisible.value = true;
    };
    // 获取子场景分类列表
    const deleteSubScenario = async record => {
      try {
        const {
          code
        } = await deleteSubScenarioFetch({
          subScenarioId: record.subScenarioId
        });
        if (code === '0000') {
          message.success('删除成功');
          getSubScenarioList();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '场景配置',
              element_name: '删除子场景'
            }
          });
        }
      } catch (error) {}
    };
    // 获取场景分类列表
    const getScenarioList = async () => {
      try {
        loading.value = true;
        const {
          code,
          data: {
            list
          }
        } = await getScenarioListFetch();
        if (code === '0000') {
          var _scenarioList$value;
          scenarioList.value = list;
          if ((_scenarioList$value = scenarioList.value) !== null && _scenarioList$value !== void 0 && _scenarioList$value.length) {
            var _scenarioList$value2;
            changeCurScenario((_scenarioList$value2 = scenarioList.value) === null || _scenarioList$value2 === void 0 ? void 0 : _scenarioList$value2[0]);
          }
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    const changeCurScenario = item => {
      curScenarioItem.value = {
        ...item
      };
      getSubScenarioList();
    };
    const getScenarioName = scenarioId => {
      var _scenarioList$value$f;
      return ((_scenarioList$value$f = scenarioList.value.find(item => item.scenarioId === scenarioId)) === null || _scenarioList$value$f === void 0 ? void 0 : _scenarioList$value$f.scenarioName) || '';
    };
    // 获取子场景分类列表
    const getSubScenarioList = async () => {
      var _curScenarioItem$valu;
      if (!((_curScenarioItem$valu = curScenarioItem.value) !== null && _curScenarioItem$valu !== void 0 && _curScenarioItem$valu.scenarioId)) {
        return;
      }
      try {
        configloading.value = true;
        const {
          code,
          data: {
            list
          }
        } = await getSubScenarioListFetch({
          scenarioId: curScenarioItem.value.scenarioId
        });
        if (code === '0000') {
          subScenarioList.value = list;
        }
      } catch (error) {} finally {
        configloading.value = false;
      }
    };
    onBeforeMount(() => {
      getScenarioList();
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_table = _resolveComponent("a-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(TopTitle, {
        title: "场景分类",
        btnName: "添加场景",
        onAdd: addCategory,
        showRightBtn: false
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          style: _normalizeStyle({
            width: item.width + 'px'
          })
        }, _toDisplayString(item.title), 5);
      }), 128))]), _createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => [scenarioList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scenarioList.value, item => {
          var _curScenarioItem$valu2;
          return _openBlock(), _createElementBlock("div", {
            key: item.scenarioId,
            class: _normalizeClass(["body_item", {
              active: item.scenarioId === ((_curScenarioItem$valu2 = curScenarioItem.value) === null || _curScenarioItem$valu2 === void 0 ? void 0 : _curScenarioItem$valu2.scenarioId)
            }]),
            onClick: $event => changeCurScenario(item)
          }, [_createElementVNode("div", {
            class: "code",
            title: item.scenarioCode
          }, _toDisplayString(item.scenarioCode), 9, _hoisted_7), _createElementVNode("div", {
            class: "app_name",
            title: item.scenarioName
          }, _toDisplayString(item.scenarioName), 9, _hoisted_8)], 10, _hoisted_6);
        }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
          key: 1,
          image: _unref(simpleImage)
        }, null, 8, ["image"]))]),
        _: 1
      }, 8, ["spinning"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(TopTitle, {
        title: "场景管理",
        btnName: "添加子场景",
        showRightBtn: false,
        onAdd: addConfig
      }), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_table, {
        bordered: "",
        columns: _unref(configColumns),
        loading: configloading.value,
        "data-source": subScenarioList.value,
        "row-key": "subScenarioId",
        pagination: false
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'scenarioName' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(getScenarioName(record.scenarioId) || '--'), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'remark' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 1,
          placement: "topLeft",
          overlayStyle: {
            maxWidth: '800px'
          }
        }, _createSlots({
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(record.remark || '--'), 1)]),
          _: 2
        }, [record.remark ? {
          name: "title",
          fn: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(record.remark), 1)]),
          key: "0"
        } : undefined]), 1024)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [record.editable === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("a", {
          onClick: $event => editSubScenario(record),
          class: "edit_btn"
        }, "编辑", 8, _hoisted_12), _createVNode(_component_a_popconfirm, {
          placement: "rightBottom",
          title: "确定删除该子场景吗?",
          onConfirm: $event => deleteSubScenario(record)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 2
        }, 1032, ["onConfirm"])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "loading", "data-source"])])]), _createVNode(AddConfigModal, {
        "modal-visible": addConfigVisible.value,
        "onUpdate:modal-visible": _cache[0] || (_cache[0] = $event => addConfigVisible.value = $event),
        scenarioList: scenarioList.value,
        editItem: subScenarioItem.value,
        onUpdateList: getSubScenarioList
      }, null, 8, ["modal-visible", "scenarioList", "editItem"])]);
    };
  }
});